export default __webpack_public_path__ + "static/media/logo-oversinerco.3a2d05c6.svg";